module.exports = __webpack_public_path__ + "static/media/aiddas.903ac43a.png";